import { createFileRoute, notFound } from '@tanstack/react-router'
import { getStaticPage } from '@/src/lib/static-pages'
import { Markdown } from '@/src/components/Markdown'
import { NotFound } from '@/src/components/NotFound'
import { useTranslation } from '@/src/i18n/client'

export const Route = createFileRoute('/_static/legal')({
  loader: () => {
    const enPage = getStaticPage('legal', 'en')
    const dePage = getStaticPage('legal', 'de')
    
    if (!enPage && !dePage) {
      throw notFound()
    }
    
    return { enPage, dePage }
  },
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.enPage?.title || 'Legal Notice - GearLens' },
      { name: 'description', content: loaderData?.enPage?.description || 'Legal information and contact details' }
    ],
  }),
  component: LegalNoticePage,
})

function LegalNoticePage() {
  const { i18n } = useTranslation()
  const { enPage, dePage } = Route.useLoaderData()
  
  const currentLocale = i18n.language.split('-')[0]
  const page = currentLocale === 'de' ? dePage : enPage
  
  if (!page) {
    return <NotFound />
  }

  return (
    <div className="container mx-auto max-w-7xl py-8">
      <Markdown 
        content={page.content} 
        className="prose prose-gray dark:prose-invert max-w-none"
      />
    </div>
  )
}
